import React from 'react';
import { useTranslation } from 'react-i18next';
import Style from '../style';
import AnalysisWidget from '../../widget';
import Overview from '../../programs-widgets/overview';
import InvestmentData from '../../amp-widgets/repayment-overview';
import MinePipeline from '../../programs-widgets/production-data';
import KeyIndicators from '../../programs-widgets/key-indicators';
import MineralCredits from '../../programs-widgets/mineral-credits';
import ProductionData from '../../amp-widgets/production-data-value';
import AmpsMap from '../../../Modules/tif/screens/dashboard/widgets/amps-map';

const productionData = [
  { date: 'M01', Score: 0, key: 1 },
  { date: 'M02', Score: 0, key: 2 },
  { date: 'M03', Score: 0, key: 3 },
  { date: 'M04', Score: 0, key: 4 },
  { date: 'M05', Score: 0, key: 5 },
  { date: 'M06', Score: 0, key: 6 },
  { date: 'M07', Score: 0, key: 7 },
  { date: 'M08', Score: 0, key: 8 },
  { date: 'M09', Score: 0, key: 9 },
  { date: 'M10', Score: 0, key: 10 },
  { date: 'M11', Score: 0, key: 11 },
  { date: 'M12', Score: 0, key: 12 },
];

export default function ProgramsLayout({
  id,
  data = null,
  other = {},
  redirectToView = () => { },
  getOption = () => { },
}) {
  const { t } = useTranslation();

  if (data) {
    return (
      <div>
        <Style>
          <div className="sections-cont mt-6">
            <section>
              <Overview data={data} />
              <MineralCredits data={data} />
            </section>

            <section>
              <AmpsMap data={data?.amps} options={data?.options} />
            </section>

            <section>
              <KeyIndicators data={data} />
            </section>

            <section>
              <MinePipeline amps={data?.amps || []} />
            </section>

            <AnalysisWidget
              className="with-border-header"
              title={t('Economic performance')}>
              <section>
                <InvestmentData title="Investment Data" data={data} />
                <ProductionData
                  data={productionData}
                  getItems={({ score, fill }) => [
                    { label: 'Average', color: fill, value: '0kg' },
                    { label: 'Month', color: fill, value: '0g' },
                    { label: 'Total value', color: fill, value: `$${score}` },
                  ]}
                />
              </section>
            </AnalysisWidget>
          </div>
        </Style>
      </div>
    );
  }

  return null;
}
